import React from 'react';
import { useHistory, RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';

import navRoutes from 'navigation/Routes';

import { PLATFORM } from 'constants/env';
import { PLATFORM_DISPLAY_NAME } from 'constants/common';

// @ts-ignore
import imgPhone from 'assets/images/download/workshop-signup-mobile.png'; // @ts-ignore
import imgQr from 'assets/images/download/download-workshop-qr.png'; // @ts-ignore
import imgGooglePlay from 'assets/images/download/google-play-button.png'; // @ts-ignore
import imgIOs from 'assets/images/download/ios-app-store-button.webp';

import { BrandLg } from 'components/Brand';

import { Flex, Heading, Text, LinkButton, Card, Image } from '@workshop/ui';

interface MatchParams {}

interface Props extends RouteComponentProps<MatchParams> {}

const DownloadScreen: React.FC<Props> = ({}) => {
  const history = useHistory();

  if (PLATFORM === 'steppit') {
    history.push(navRoutes.public.login.path());
    return null;
  }

  return (
    <Flex
      position="absolute"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100vw"
      minHeight="100vh"
      py={12}
      backgroundColor="background.tint3"
    >
      <Link to="/">
        <BrandLg mb={10} />
      </Link>
      <Card>
        <Flex
          gap={4}
          p={8}
          alignItems="center"
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <Flex flex={1}>
            <Image
              src={imgPhone}
              alt="Workshop mobile app"
              style={{ maxHeight: '500px' }}
            />
          </Flex>

          <Flex
            flex={1}
            flexDirection="column"
            alignItems="center"
            textAlign="center"
          >
            <Heading
              maxWidth={220}
              as="h1"
              fontSize="3xl"
              fontWeight="extrabold"
              mb={2}
            >
              Download the Workshop app
            </Heading>

            <Text mb={6} fontWeight="semibold">
              For the best course experience
            </Text>

            <Image
              src={imgQr}
              alt="QR Code"
              width={180}
              height={180}
              style={{ marginBottom: '24px' }}
            />

            <Flex gap={4} mb={4}>
              <a
                href="https://apps.apple.com/app/workshop-learn-new-skills/id1236125772"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src={imgIOs}
                  alt="Download on the App Store"
                  height={12}
                  objectFit="contain"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=ws.workshop.app&hl=en&pli=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src={imgGooglePlay}
                  alt="Get it on Google Play"
                  height={12}
                  objectFit="contain"
                />
              </a>
            </Flex>

            <Text fontWeight="semibold" color="text.muted" mb={6}>
              Search 'Workshop – Learn New Skills' in the App Store
            </Text>

            <Flex position="relative" width="100%" alignItems="center" mb={6}>
              <Flex height="1px" backgroundColor="border.default" flex={1} />
              <Text px={4} color="text.muted" fontSize="sm">
                OR
              </Text>
              <Flex height="1px" backgroundColor="border.default" flex={1} />
            </Flex>

            <LinkButton
              to={navRoutes.common.home.path()}
              variant="ghost"
              icon="ArrowForward"
              iconPosition="right"
            >
              Open Workshop Web
            </LinkButton>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};

export default DownloadScreen;
